var _rect, _g, _path, _g2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhyUs2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 74,
    viewBox: "0 0 75 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 74,
    height: 74,
    rx: 37,
    fill: "#B9CFE4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_327_1956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3353 15.6724C37.056 15.2563 37.944 15.2563 38.6647 15.6724L55.3879 25.3276C56.1086 25.7437 56.5526 26.5127 56.5526 27.3449V46.6551C56.5526 47.4873 56.1086 48.2563 55.3879 48.6724L38.6647 58.3276C37.944 58.7437 37.056 58.7437 36.3353 58.3276L19.6121 48.6724C18.8914 48.2563 18.4474 47.4873 18.4474 46.6551V27.3449C18.4474 26.5127 18.8914 25.7437 19.6121 25.3276L36.3353 15.6724Z",
    fill: "url(#paint0_linear_327_1956)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3351 15.6724C37.0558 15.2563 37.9438 15.2563 38.6645 15.6724L56.1195 25.7501C56.3874 25.9047 56.5524 26.1906 56.5525 26.4999C56.5525 26.8094 56.3875 27.0953 56.1195 27.2501L38.6647 37.3276C37.944 37.7437 37.056 37.7437 36.3353 37.3276L18.8804 27.2499C18.6125 27.0953 18.4474 26.8094 18.4474 26.5001C18.4473 26.1906 18.6124 25.9047 18.8804 25.7499L36.3351 15.6724Z",
    fill: "url(#paint1_linear_327_1956)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_327_1956)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 37.4344,
    y1: 38.6165,
    x2: 37.4344,
    y2: 56.4753,
    stroke: "url(#paint2_linear_327_1956)",
    strokeWidth: 0.388235,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_327_1956",
    x: 17.2826,
    y: 14.1956,
    width: 42.7643,
    height: 47.9381,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.16471,
    dy: 1.16471
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.16471
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_327_1956"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_327_1956",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_327_1956",
    x: 36.0755,
    y: 37.2577,
    width: 5.0475,
    height: 22.9059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.16471,
    dy: 1.16471
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.16471
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_327_1956"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_327_1956",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_327_1956",
    x1: 59.5,
    y1: 15,
    x2: 15.5,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90278F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B491FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_327_1956",
    x1: 56.5526,
    y1: 15,
    x2: 18.4473,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC5DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B491FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_327_1956",
    x1: 37.2402,
    y1: 47.5459,
    x2: 36.2402,
    y2: 47.5459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC78EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyUs2);
export default __webpack_public_path__ + "static/media/why-us-2.0d5351711510e8156558e51b59940b78.svg";
export { ForwardRef as ReactComponent };